import script from "./OidcSignOut.vue?vue&type=script&lang=js"
export * from "./OidcSignOut.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__